<template>
  <div
      class="eq-window-nested-blue"
      style="margin-top: 20px; overflow-y: scroll; height: 70vh;"
      v-if="servers"
  >
    <table
        id="server-listings"
        class="eq-table eq-highlight-rows"
        style="display: table; font-size: 16px; padding: 10px"
    >
      <thead>
      <tr>
        <th style="text-align: center; width: 10px">Players</th>
        <th>Status</th>
        <th>Server</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(server, index) in servers" :key="server.world_id">
        <td style="text-align: center">{{ server.players_online }}</td>
        <td style="text-align: center">
          <span style="color: #00ff00; font-weight: bold">UP</span>
        </td>
        <td>
          {{ server.server_long_name }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "ServerTableComponent",
  props: {
    servers: Object
  }
}
</script>

<style scoped>

</style>
